module.exports = __webpack_public_path__ + "static/media/item-list.8c344b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/item-list.png
// module id = 2924
// module chunks = 0